import { defineComponent, h, TransitionGroup, type TransitionGroupProps } from 'vue'
import { transitionProps } from './transitionProps'

export default defineComponent({
  name: 'BasicTransition',
  props: {
    ...transitionProps,
  },
  render() {
    const props: TransitionGroupProps = this.$props
    return h(TransitionGroup, props, this.$slots)
  },
})
